import { useSubmitGuard } from "@/hooks/useSubmitGuard";
import {
	type AutocompleteFetcher,
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	FormBuilder,
} from "@k3-tech/react-kit";

export interface BranchBindFormValues {
	branchID: string;
	salesChannelID: string;
}

export interface BranchMenuGroupBindDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	branchFetcher: AutocompleteFetcher;
	channelOptions: { value: string; label: string }[];
	onSubmit: (values: BranchBindFormValues) => unknown;
}

export function BranchMenuGroupBindDialog({
	open,
	onOpenChange,
	branchFetcher,
	channelOptions,
	onSubmit,
}: BranchMenuGroupBindDialogProps) {
	const { isSubmitting, guardedSubmit } = useSubmitGuard(onSubmit);

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle>Bind Branch</DialogTitle>
				</DialogHeader>
				<FormBuilder<BranchBindFormValues>
					onSubmit={guardedSubmit}
					isSubmitting={isSubmitting}
					onCancel={() => onOpenChange(false)}
					actionsClassName="justify-end"
					showActionsSeparator={false}
					sections={[
						{
							layout: "grid",
							grid: { cols: 1, gap: "gap-4" },
							fields: [
								{
									name: "branchID",
									label: "Branch",
									type: "autocomplete",
									options: [],
									autocompleteMode: "server",
									fetcher: branchFetcher,
									placeholder: "Search branch",
									required: true,
									defaultValue: null,
								},
								{
									name: "salesChannelID",
									label: "Channel",
									type: "select",
									options: channelOptions,
									placeholder: "Select channel",
									required: true,
									defaultValue: null,
									className: "w-full",
								},
							],
						},
					]}
					submitLabel="Bind"
				/>
			</DialogContent>
		</Dialog>
	);
}
